class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseover', this.onHover.bind(this));
    this.mainDetailsToggle.addEventListener('mouseout', this.onmouseOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }
 
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onHover() {}

  onmouseOut() {}

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;

    // Hover open/close is driven from the whole <header-menu> element
    // (the nav label + its dropdown panel) using mouseenter/mouseleave,
    // with a short delay before closing. This lets the pointer travel
    // from the label down into the dropdown without it snapping shut.
    // The previous version opened on mouseover and closed on mouseout
    // bound to the <details>; because mouseout bubbles up from the
    // summary the instant the cursor left it, the menu disappeared the
    // moment the mouse moved off the top banner toward the panel.
    this.addEventListener('mouseenter', this.openMenu.bind(this));
    this.addEventListener('mouseleave', this.delayedClose.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // Neutralise the base class's bubbling mouseover/mouseout hover hooks;
  // the mouseenter/mouseleave handlers set up in the constructor replace
  // them and are immune to the bubbling that caused the premature close.
  onHover() {}

  onmouseOut() {}

  openMenu() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  delayedClose() {
    if (this.closeTimer) clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.close();
      this.closeTimer = null;
    }, 200);
  }
}

customElements.define('header-menu', HeaderMenu);